import ProposeService from "../../services/proposeService";

export const PROPOSE_CATEGORIES = "PROPOSE_CATEGORIES";

export const getCategories = () => (dispatch) => {
  return ProposeService.getCategories().then((response) => {
    dispatch({ type: PROPOSE_CATEGORIES, payload: response.data });
  });
};